import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { AppDispatch, RootState } from "../../../../../../../redux/store";
import { deletePage, fetchPages, upsertPage } from "../../../../../../../redux/blogSlice";

const AllPages: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const pages = useSelector((state: RootState) => state.blog.pages);
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(fetchPages());
  }, [dispatch]);

  const handleEdit = (id: string) => {
    navigate(`/editpages/${id}`);
  };

  const handleDuplicate = (page: any) => {
    const newPage = { ...page, title: `${page.title} Copy`, slug: `${page.slug}-copy` };
    delete newPage.id;
    dispatch(upsertPage(newPage));
  };

  const handleTrash = (id: string) => {
    dispatch(deletePage(id));
  };

  return (
    <div style={styles.container}>
      <h2 style={styles.heading}>All Pages</h2>

      <div style={styles.table}>
        <div style={styles.headerRow}>
          <div style={styles.col}>Title</div>
          <div style={styles.col}>Actions</div>
        </div>

        {pages.map((page) => (
          <div key={page.id} style={styles.row}>
            <div style={styles.col}><strong>{page.title}</strong></div>
            <div style={styles.col}>
              <span style={styles.action} onClick={() => handleEdit(page.id)}>Edit</span> |
              <span style={styles.action}> Quick Edit </span> |
              <span style={styles.action} onClick={() => handleDuplicate(page)}>Duplicate</span> |
              <span style={styles.action} onClick={() => handleTrash(page.id)}>Trash</span> |
              <span style={styles.action} onClick={() => window.open(`/pages/${page.slug}`, "_blank")}>View</span> |
              <span style={styles.action} onClick={() => navigator.clipboard.writeText(`${window.location.origin}/pages/${page.slug}`)}>Copy link</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AllPages;

const styles: { [key: string]: React.CSSProperties } = {
  container: {
    padding: "2rem",
    background: "linear-gradient(160deg, #0a0014, #1e003a, #a78bfa, #111)",
    color: "#fff",
    minHeight: "100vh",
    fontFamily: "'Segoe UI', sans-serif",
  },
  heading: {
    fontSize: "24px",
    fontWeight: 700,
    marginBottom: "1.5rem",
    textAlign: "center",
  },
  table: {
    borderTop: "1px solid #555",
  },
  headerRow: {
    display: "flex",
    padding: "0.75rem",
    borderBottom: "1px solid #444",
    fontWeight: "bold",
  },
  row: {
    display: "flex",
    padding: "0.75rem",
    borderBottom: "1px solid #333",
  },
  col: {
    flex: 1,
  },
  action: {
    cursor: "pointer",
    color: "#a78bfa",
    margin: "0 4px",
  },
};
